export default __webpack_public_path__ + "static/media/power-gauge.1ae563c2.gif";